import { Routes, Route, Outlet } from 'react-router';
import { Home } from '~pages/Home';
import { Profile } from '~pages/Profile';
import { Group } from '~pages/Group';
import { Spot } from '~pages/Spot';
import { Referral } from '~pages/Referral';
import { Verify } from '~pages/Verify';
import { Legal } from '~pages/Legal';
import { DeleteAccount } from '~pages/DeleteAccount';
import { privacyEn } from '~pages/Legal/content/privacy.en';
import { privacyEs } from '~pages/Legal/content/privacy.es';
import { biometricEn } from '~pages/Legal/content/biometric.en';
import { biometricEs } from '~pages/Legal/content/biometric.es';
import { termsEn } from '~pages/Legal/content/terms.en';
import { termsEs } from '~pages/Legal/content/terms.es';
import { guidelinesEn } from '~pages/Legal/content/guidelines.en';
import { guidelinesEs } from '~pages/Legal/content/guidelines.es';
import { SiteHeader } from '~components/SiteHeader';
import { ComingSoonDialog } from '~components/ComingSoon';

export function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route element={<Shell />}>
          <Route path="/triby/:linkId" element={<Group />} />
          <Route path="/spot/:linkId" element={<Spot />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/referral/:code" element={<Referral />} />
          <Route path="/verify/:token" element={<Verify />} />
          {/* Legal pages. Apple, Google Play and Meta all require these to be
              publicly reachable without login and without geo-blocking. */}
          <Route path="/privacy" element={<Legal doc={privacyEn} />} />
          <Route path="/es/privacy" element={<Legal doc={privacyEs} />} />
          <Route path="/biometric-notice" element={<Legal doc={biometricEn} />} />
          <Route path="/es/biometric-notice" element={<Legal doc={biometricEs} />} />
          <Route path="/terms" element={<Legal doc={termsEn} />} />
          <Route path="/es/terms" element={<Legal doc={termsEs} />} />
          <Route path="/community-guidelines" element={<Legal doc={guidelinesEn} />} />
          <Route path="/es/community-guidelines" element={<Legal doc={guidelinesEs} />} />
          {/* Play's Data safety form requires a public web URL where users can
              delete their account without reinstalling the app. */}
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="*" element={<p>Not found</p>} />
        </Route>
      </Routes>
      <ComingSoonDialog />
    </>
  );
}

// Detail pages share the landing header; Home renders its own (anchored CTA).
function Shell() {
  return (
    <>
      <SiteHeader />
      <Outlet />
    </>
  );
}
